import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import style from './style.module.less'
import { Flex } from 'hljd'
import { MEAL_TAG_IMG } from '@constant'

@inject('decorationStore')
@observer
export default class extends Component {
  render() {
    const {
      cover_path,
      title,
      actual_price,
      hot_tag,
      mode,
      new_tag,
      themeConfig,
      series,
      coupon_info,
      decorationStore: { newThemeConfig }
    } = this.props
    const isFake = mode === 'fake'
    const fakeStyle = {
      backgroundColor: '#eee',
      width: '100%',
      height: 18,
      marginBottom: 3
    }
    const fakeBottomStyle = {
      backgroundColor: '#eee',
      width: '50%',
      height: 18
    }
    const imgStyle = {
      width: 140,
      height: 140
    }
    const tagList = (new_tag || '').split(',').filter(el => el)

    return (
      <Flex className={style.item}>
        <div className={style.photo} style={imgStyle}>
          {isFake ? (
            <div className={style.fake} />
          ) : (
            <div className={style.imgWapper}>
              <img src={cover_path} />
            </div>
          )}
          <img className={style.hotTag} src={MEAL_TAG_IMG[String(hot_tag)]} />
        </div>
        <div className={style.info}>
          {isFake ? (
            <>
              <div>
                <div style={fakeStyle} />
                <div style={fakeStyle} />
              </div>
              <div style={fakeBottomStyle} />
            </>
          ) : (
            <>
              <div>
                <div className={style.title}>{title}</div>
                <div className={style.tagWapper}>
                  {tagList.map((el, i) => (
                    <span key={i} className={style.tag}>
                      {el}
                    </span>
                  ))}
                  {coupon_info && (
                    <div
                      style={{
                        color: newThemeConfig['themeColor'],
                        border: `1px solid ${newThemeConfig['themeColor']}`,
                        padding: '0 3px',
                        display: 'inline-block'
                      }}
                    >
                      {coupon_info}
                    </div>
                  )}
                </div>
              </div>
              <div>
                <p
                  className={style.price}
                  style={{
                    color: themeConfig['helper']
                  }}
                >
                  ￥{actual_price}
                </p>
                {series &&
                  series.title && (
                    <p className={style.series}>
                      <span>{series.title}系列</span>
                      <img
                        className={style.seriesIcon}
                        src="https://qnm.hunliji.com/o_1dg4kjq4q5vb14fq1li4bfic4r9.png"
                      />
                    </p>
                  )}
              </div>
            </>
          )}
        </div>
      </Flex>
    )
  }
}
